@if (form) {
  <div class="form-group" [ngClass]="field.customClass">
    <label class="mb-1">
      <span>{{ field.label }}</span>
      <span class="text-danger">{{ field.required ? "*" : "" }}</span>
    </label>

    @for (opt of field.options; track opt.key; let i = $index) {
      <ng-container *ngTemplateOutlet="checkboxTpl; context: {
        $implicit: opt,
        optionId: 'field_' + field.name + i,
        control: form.controls[i]
      }"></ng-container>
    }
  </div>
}

<ng-template #checkboxTpl let-option let-optionId="optionId" let-control="control">
  <div class="form-check">
    <input
      type="checkbox"
      class="form-check-input"
      [formControl]="control"
      [id]="optionId"
      [attr.disabled]="disabled || null"
    />
    <label class="form-check-label" [for]="optionId">
      {{ option.value }}
    </label>
  </div>
</ng-template>
